module.exports = require("events");